<template>
  <div class="my-case-container">
    <!-- 顶部操作栏 -->
    <div class="top-bar">
      <el-input
        placeholder="请输入案号"
        v-model="searchQuery"
        class="search-input"
        @keyup.enter.native="handleSearch"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" @click="handleNewCase">新增案件</el-button>
    </div>

    <!-- 案件列表 -->
    <el-table :data="caseList" style="width: 100%" class="case-table" v-loading="loading">
      <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
      <el-table-column prop="caseNumber" label="案号"></el-table-column>
      <el-table-column label="仲裁员">
        <template slot-scope="scope">
          <span v-if="scope.row.arbitrators && scope.row.arbitrators.length">
            <span v-for="(item, idx) in scope.row.arbitrators" :key="idx">
              <span v-if="item.isMain" style="font-weight:bold;color:#409EFF;">{{ item.name }}(主)</span>
              <span v-else>{{ item.name }}</span>
              <span v-if="idx !== scope.row.arbitrators.length - 1">，</span>
            </span>
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="clerkName" label="书记员"></el-table-column>
      <el-table-column prop="applicantName" label="仲裁申请人"></el-table-column>
      <el-table-column prop="latestHearingTime" label="开庭时间 (最近一次)"></el-table-column>
      <el-table-column prop="latestHearingLocation" label="仲裁员开庭地点 (最近一次)"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleEditCase(scope.row)" type="text" size="small">编辑案件</el-button>
          <el-button @click="handleNewHearing(scope.row)" type="text" size="small">新增开庭</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增开庭弹窗 -->
    <el-dialog
      :visible.sync="showHearingDialog"
      title="新增开庭"
      width="600px"
      :show-close="true"
      :close-on-click-modal="false"
      @close="onHearingDialogClose"
    >
      <NewHearing
        v-if="showHearingDialog"
        :context="'case-list'"
        :case-id="currentCaseId"
        @cancel="showHearingDialog = false"
        @saved="onHearingSaved"
      />
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import NewHearing from './NewHearing.vue'

export default {
  name: 'MyCase',
  components: { NewHearing },
  data() {
    return {
      loading: false,
      searchQuery: '',
      caseList: [],
      page: 1,
      size: 10,
      total: 0,
      form: {
        caseName: '',
        caseNumber: '',
        // ...其他字段
      },
      rules: {
        caseName: [{ required: true, message: '请输入案件名称', trigger: 'blur' }],
        caseNumber: [{ required: true, message: '请输入案号', trigger: 'blur' }],
        // ...其他字段
      },
      showHearingDialog: false,
      currentCaseId: '',
    };
  },
  mounted() {
    this.fetchCases();
  },
  methods: {
    // 获取案件列表
    async fetchCases() {
      this.loading = true;
      try {
        const res = await request.get('/api/case/my', {
          params: {
            page: this.page,
            size: this.size,
            query: this.searchQuery,
          }
        });
        if (res.code === 200) {
          this.caseList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error('数据加载失败');
          this.caseList = [];
          this.total = 0;
        }
      } catch (error) {
        this.$message.error('请求失败，请检查网络');
      } finally {
        this.loading = false;
      }
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.fetchCases();
    },
    // 新增案件
    handleNewCase() {
      // 新开标签页跳转到案件编辑页
      const url = this.$router.resolve({ name: 'CaseEdit' }).href; // 获取路由对应的完整URL
      window.open(url, '_blank'); // 新窗口打开
    },
    // 编辑案件
    handleEditCase(row) {
      // 新开标签页跳转到案件编辑页，并带上caseId参数
      const url = this.$router.resolve({ name: 'CaseEdit', params: { caseId: row.caseId } }).href; // 获取路由对应的完整URL
      window.open(url, '_blank'); // 新窗口打开
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.fetchCases();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.page = val;
      this.fetchCases();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        // 这里才发POST请求
        this.$axios.post('/api/case/create', this.form)
          .then(res => {
            this.$message.success('保存成功');
            // 跳转或刷新
          });
      });
    },
    // 点击"新增开庭"按钮，弹出弹窗
    handleNewHearing(row) {
      console.log('点击新增开庭按钮', row); // 调试信息
      
      // 设置案件ID
      this.currentCaseId = row.caseId;
      console.log('设置案件ID:', this.currentCaseId); // 调试信息
      
      // 显示弹窗
      this.showHearingDialog = true;
    },
    // 弹窗关闭时重置数据
    onHearingDialogClose() {
      this.currentCaseId = ''
    },
    // 新增开庭弹窗保存后回调
    onHearingSaved(formData) {
      this.showHearingDialog = false
      this.$message.success('保存成功')
      this.fetchCases()
    },
  }
};
</script>

<style scoped>
.my-case-container {
  padding: 20px;
  background-color: #fff;
  min-height: calc(100vh - 50px);
  /* 隐藏右侧滚动条 */
  overflow-y: hidden; /* 禁止垂直方向的滚动条显示 */
}
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.search-input {
  width: 300px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style> 